import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const NotificationBar = () => {
    const [open, setOpen] = useState(true);

    // Example notification content - in a real app, this could come from props or an API
    const notification = {
        text: "Ship across Canada with SolushipX. No subscription, no card to start: pay per shipment.",
        link: "/signup",
        linkText: "Create an account"
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Collapse in={open}>
            <Box
                sx={{
                    bgcolor: '#000000',
                    color: '#ffffff',
                    py: { xs: 1, sm: 1 },
                    px: { xs: 1.5, sm: 2 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '100%',
                    minHeight: { xs: '44px', sm: 'auto' }
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                        flex: 1,
                        pr: { xs: 5.5, sm: 5 },
                        maxWidth: '100%',
                        overflow: 'hidden'
                    }}
                >
                    <Typography
                        variant="body2"
                        component="div"
                        sx={{
                            fontWeight: 500,
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            lineHeight: { xs: 1.3, sm: 1.5 }
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                display: { xs: 'inline', sm: 'inline' }
                            }}
                        >
                            {notification.text}
                        </Box>
                        {' '}
                        {notification.link && (
                            <Box
                                component="a"
                                href={notification.link}
                                sx={{
                                    color: '#2C6ECB',
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    display: 'inline',
                                    whiteSpace: 'nowrap',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                {notification.linkText}
                            </Box>
                        )}
                    </Typography>
                </Box>
                <IconButton
                    size="small"
                    onClick={handleClose}
                    sx={{
                        color: '#ffffff',
                        position: 'absolute',
                        right: { xs: 2, sm: 8 },
                        minWidth: { xs: '44px', sm: '36px' },
                        minHeight: { xs: '44px', sm: '36px' },
                        padding: { xs: '12px', sm: '8px' },
                        '&:hover': {
                            color: '#2C6ECB'
                        }
                    }}
                >
                    <CloseIcon sx={{ fontSize: { xs: '1.25rem', sm: '1.25rem' } }} />
                </IconButton>
            </Box>
        </Collapse>
    );
};

export default NotificationBar; 